module.exports = __webpack_public_path__ + "img/zhucetishi1.b924883a.png";